// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../AuctionRoomSharedContacts.bs.js";

function RegistrationPendingAgentModal$InfoToSend(props) {
  var t = props.t;
  return React.createElement("ul", {
              className: Curry._1(Css.style, {
                    hd: Css.listStyleType("disc"),
                    tl: {
                      hd: Css.marginLeft(Css.px(26)),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement("li", undefined, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                      children: Curry._1(t, "EnrollmentPendingAgentModal_photoIdOfThePrincipal")
                    })), React.createElement("li", undefined, React.createElement(SterlingTypography$LiveRoom.Label16Medium.make, {
                      children: Curry._1(t, "EnrollmentPendingAgentModal_writtenAuthorization")
                    })));
}

var InfoToSend = {
  make: RegistrationPendingAgentModal$InfoToSend
};

function RegistrationPendingAgentModal$Paragraph16Regular(props) {
  return React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                          tl: /* [] */0
                        }),
                    tl: {
                      hd: Curry._1(Css.style, Belt_Option.getWithDefault(props.additionalStyles, /* [] */0)),
                      tl: /* [] */0
                    }
                  }),
              children: props.text
            });
}

var Paragraph16Regular = {
  make: RegistrationPendingAgentModal$Paragraph16Regular
};

function RegistrationPendingAgentModal(props) {
  var onClose = props.onClose;
  var sapAuctionSaleNumber = props.sapAuctionSaleNumber;
  React.useEffect((function () {
          AnalyticsManager$LiveRoom.actionNeededPendingEnrollmentViewed(sapAuctionSaleNumber, undefined, "LiveRoom", undefined, undefined, "PendingBiddingAgent");
        }), []);
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var match$1 = AuctionRoomSharedContacts$LiveRoom.getEmailAndPhoneByAuctionLocation(AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType(props.location));
  var locationEmail = match$1[0];
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                          hd: Css.width(Css.pct(100)),
                          tl: {
                            hd: Css.height(Css.pct(100)),
                            tl: {
                              hd: Css.important(Css.maxHeight(Css.pct(100))),
                              tl: {
                                hd: Css.important(Css.maxWidth(Css.pct(100))),
                                tl: /* [] */0
                              }
                            }
                          }
                        }),
                    tl: /* [] */0
                  }),
              onClose: onClose,
              isOpen: true,
              size: "large",
              headerTitle: Curry._1(t, "EnrollmentPendingAgentModal_title")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: null
                }, React.createElement("div", {
                      className: Curry._1(Css.style, {
                            hd: Css.display("flex"),
                            tl: {
                              hd: Css.height(Css.px(88)),
                              tl: /* [] */0
                            }
                          })
                    }, React.createElement(SterlingIcons$LiveRoom.Collection.Exclamation24Filled.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.transform({
                                      NAME: "scale",
                                      VAL: [
                                        4,
                                        4
                                      ]
                                    }),
                                tl: {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.alertOrange60_nohashtag)),
                                  tl: {
                                    hd: Css.margin("auto"),
                                    tl: /* [] */0
                                  }
                                }
                              })
                        })), React.createElement(RegistrationPendingAgentModal$Paragraph16Regular, {
                      text: Curry._1(t, "EnrollmentPendingAgentModal_caption"),
                      additionalStyles: {
                        hd: Css.paddingTop(Css.px(24)),
                        tl: {
                          hd: Css.marginBottom(Css.px(24)),
                          tl: {
                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }), React.createElement(RegistrationPendingAgentModal$Paragraph16Regular, {
                      text: Curry._1(t, "EnrollmentPendingAgentModal_pleaseEmail") + " ",
                      additionalStyles: {
                        hd: Css.display("inline"),
                        tl: /* [] */0
                      }
                    }), React.createElement(SterlingTypography$LiveRoom.Paragraph16LinkRegular.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                            tl: {
                              hd: Css.textDecoration("none"),
                              tl: {
                                hd: Css.display("inline"),
                                tl: /* [] */0
                              }
                            }
                          }),
                      href: "mailto: " + locationEmail,
                      children: locationEmail
                    }), React.createElement(RegistrationPendingAgentModal$Paragraph16Regular, {
                      text: " " + Curry._1(t, "EnrollmentPendingAgentModal_withFollowingInfo"),
                      additionalStyles: {
                        hd: Css.display("inline"),
                        tl: /* [] */0
                      }
                    }), React.createElement(RegistrationPendingAgentModal$InfoToSend, {
                      t: t
                    }), React.createElement(RegistrationPendingAgentModal$Paragraph16Regular, {
                      text: Curry._1(t, "EnrollmentPendingAgentModal_ourBidsTeamMayContact"),
                      additionalStyles: {
                        hd: Css.marginTop(Css.px(16)),
                        tl: /* [] */0
                      }
                    }), React.createElement(RegistrationPendingAgentModal$Paragraph16Regular, {
                      text: Curry._1(t, "EnrollmentPendingAgentModal_antiMoneyLaundering"),
                      additionalStyles: {
                        hd: Css.marginTop(Css.px(24)),
                        tl: /* [] */0
                      }
                    })), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(onClose, undefined);
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.important(Css.width(Css.px(152))),
                              tl: /* [] */0
                            }),
                        children: Curry._1(t, "Common_iUnderstand")
                      })
                }));
}

var make = RegistrationPendingAgentModal;

export {
  InfoToSend ,
  Paragraph16Regular ,
  make ,
}
/* Css Not a pure module */
